import { render, staticRenderFns } from "./RbCheckboxButton.vue?vue&type=template&id=5cf8d10e"
import script from "./RbCheckboxButton.vue?vue&type=script&lang=js"
export * from "./RbCheckboxButton.vue?vue&type=script&lang=js"
import style0 from "./RbCheckboxButton.vue?vue&type=style&index=0&id=5cf8d10e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports